import { useState, useEffect } from "react";
import "../styles/ContestGallery.css";
import { addGlowEffect } from "../glowEffect";
import { Link } from "react-router-dom";

function ContestGallery() {
  const [entries, setEntries] = useState([]);
  const [selectedVotes, setSelectedVotes] = useState({});
  const [carouselIndex, setCarouselIndex] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 10;
  const [isContestOpen, setIsContestOpen] = useState(true);

  useEffect(() => {
    addGlowEffect();
  }, []);

  useEffect(() => {
    // Check contest deadline
    const deadline = new Date("2025-12-24T23:59:59");
    const now = new Date();
    if (now > deadline) {
      setIsContestOpen(false);
      return;
    }

    // Fetch participants
    fetch("https://holidaylights.tamarac.gov/api/participants")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setEntries(data);
        else setEntries([]);
      })
      .catch((err) => {
        console.error("Error fetching entries:", err);
        setEntries([]);
      });
  }, []);

  // Handle voting
  const handleVote = (id) => {
    //fetch(`http://localhost:5000/api/vote/${id}`, { method: "POST" })
  //console.log("📤 Enviando voto para ID:", id);

  fetch(`https://holidaylights.tamarac.gov/api/vote/${id}`, { method: "POST" })
    .then((res) => {
     // console.log("📥 Respuesta cruda del servidor:", res);
      return res.json(); 
    })
    .then((data) => {
      console.log("✅ JSON recibido:", data);
      alert("🎉 Thanks for voting!");
      setSelectedVotes((prev) => ({ ...prev, [id]: true }));
    })
    .catch((err) => console.error("❌ Voting error:", err));
};


  // Carousel navigation
  const nextMedia = (id, total) => {
    setCarouselIndex((prev) => ({
      ...prev,
      [id]: prev[id] === undefined ? 1 : (prev[id] + 1) % total,
    }));
  };

  const prevMedia = (id, total) => {
    setCarouselIndex((prev) => ({
      ...prev,
      [id]: prev[id] === undefined ? total - 1 : (prev[id] - 1 + total) % total,
    }));
  };

  // Render image or video
  const renderMedia = (media) => {
    if (!media) return null;

    if (media.type === "video") {
      return (
        <video className="carousel-image" controls>
          <source
            src={`https://holidaylights.tamarac.gov/uploads/${media.url}`}
            type="video/mp4"
          />
        </video>
      );
    }

    return (
      <img
        src={`https://holidaylights.tamarac.gov/uploads/${media.url}`}
        alt="Entry media"
        className="carousel-image"
      />
    );
  };

  // Pagination logic
  const entriesArray = Array.isArray(entries) ? entries : [];
  const totalPages = Math.ceil(entriesArray.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentEntries = entriesArray.slice(indexOfFirst, indexOfLast);

  return (
    <div className="contest-gallery">
      <div className="grid">
        {currentEntries.map((entry) => {
          const mediaArray = Array.isArray(entry.images) ? entry.images : [];

          return (
            <div key={entry.id} className="entry-card">
              <h3>{entry.address}</h3>

              {mediaArray.length > 1 ? (
                <div className="carousel">
                  <button
                    className="carousel-btn left"
                    onClick={() => prevMedia(entry.id, mediaArray.length)}
                  >
                    ‹
                  </button>

                  {renderMedia(mediaArray[carouselIndex[entry.id] || 0])}

                  <button
                    className="carousel-btn right"
                    onClick={() => nextMedia(entry.id, mediaArray.length)}
                  >
                    ›
                  </button>
                </div>
              ) : (
                <div className="single-media">
                  {renderMedia(mediaArray[0])}
                </div>
              )}

              <button
                disabled={selectedVotes[entry.id]}
                onClick={() => handleVote(entry.id)}
                className="vote-btn"
              >
                {selectedVotes[entry.id] ? "✅ Voted" : "Vote for this House"}
              </button>
            </div>
          );
        })}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => prev - 1)}
            disabled={currentPage === 1}
          >
            ⬅ Previous
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() => setCurrentPage((prev) => prev + 1)}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}

      {/* Back to main page button */}
      <Link to="/" className="home-btn">
        ⬅️ Back to Main Page
      </Link>
    </div>
  );
}

export default ContestGallery;
